import { type ComponentType, lazy } from 'react';
import * as Sentry from '@sentry/react';
import { ProjectErrorBoundary } from '@/components/ProjectErrorBoundary.tsx';

export const HomePage = lazy(() =>
  import('@/pages/Home/HomePage.tsx').then((m) => ({ default: m.HomePage })),
);
export const ClientsPage = lazy(() =>
  import('@/pages/Clients/ClientsPage.tsx').then((m) => ({
    default: m.ClientsPage,
  })),
);
export const ClientPage = lazy(() =>
  import('@/pages/Client/ClientPage.tsx').then((m) => ({
    default: m.ClientPage,
  })),
);
export const IOSTenantsPage = lazy(() =>
  import('@/pages/iOSTenants/IOSTenantsPage.tsx').then((m) => ({
    default: m.IOSTenantsPage,
  })),
);

interface RouteErrorBoundaryProps {
  PageComponent: ComponentType;
  tag: string;
}

export function RouteErrorBoundary({ PageComponent, tag }: RouteErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        scope.setTag('location', tag);
      }}
      fallback={(props) => (
        <ProjectErrorBoundary
          error={props.error}
          componentStack={props.componentStack}
          resetError={() => {
            props.resetError();
          }}
        />
      )}
    >
      <PageComponent />
    </Sentry.ErrorBoundary>
  );
}

export function HomeRoute() {
  return <RouteErrorBoundary PageComponent={HomePage} tag="home" />;
}

export function ClientsRoute() {
  return <RouteErrorBoundary PageComponent={ClientsPage} tag="clients" />;
}

export function ClientRoute() {
  return <RouteErrorBoundary PageComponent={ClientPage} tag="clients/:clientId" />;
}

export function IOSTenantsRoute() {
  return <RouteErrorBoundary PageComponent={IOSTenantsPage} tag="app-configurations" />;
}
